import { apiClient } from '@/shared/api';

import type {
  BrowseCategoriesParams,
  Category,
  CategoryDetail,
  CategoryListRequest,
  CategoryListResponse,
  CategorySummaryPage,
  CategoryUpsertRequest,
  ImportResult,
} from '../model/types';

const BASE = '/api/v1/catalog/categories';
const MASTER_BASE = '/api/v1/catalog/master/categories';

export const listCategories = async (
  body: CategoryListRequest = {},
): Promise<CategoryListResponse> =>
  (await apiClient.post<CategoryListResponse>(BASE, body)).data;

export const getCategory = async (categoryId: string): Promise<Category> =>
  (await apiClient.get<Category>(`${BASE}/${categoryId}`)).data;

/**
 * Search master-catalog categories — epic-catalog-002, story-024.
 * POST so the filter (incl. exact UUID `ids`) rides in the body and is searched in OpenSearch.
 */
export const searchCategories = async (
  filter: BrowseCategoriesParams = {},
): Promise<CategorySummaryPage> =>
  (await apiClient.post<CategorySummaryPage>(`${BASE}/search`, filter)).data;

export const createCategory = async (
  body: CategoryUpsertRequest,
): Promise<CategoryDetail> => (await apiClient.post<CategoryDetail>(MASTER_BASE, body)).data;

export const getMasterCategory = async (categoryId: string): Promise<CategoryDetail> =>
  (await apiClient.get<CategoryDetail>(`${MASTER_BASE}/${categoryId}`)).data;

export const deleteCategory = async (categoryId: string): Promise<void> => {
  await apiClient.delete(`${BASE}/${categoryId}`);
};

export const upsertCategory = async (
  categoryId: string,
  body: CategoryUpsertRequest,
): Promise<ImportResult> => (await apiClient.put<ImportResult>(`${BASE}/${categoryId}`, body)).data;
